// TestHarness.js
import React, { useState, useEffect } from 'react';
import { IonApp, IonContent, setupIonicReact } from '@ionic/react';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

import ViewHealthData from './ViewHealthData';

// Initialize Ionic React
setupIonicReact();

const ViewHealthDataTestHarness = () => {
  // Get auth data from URL parameters 

  const member_id = '26';
  const user_id = '14';
  const auth_token = 'eyJhbGciOiJBMjU2S1ciLCJlbmMiOiJBMjU2Q0JDLUhTNTEyIiwiemlwIjoiREVGIn0.ER9JqPQdqEDcWM2SpbJcqme742OW8hzUevT7A2t4PEt8zU0XSq6vvpaJcMzi0zUYD_RgmFqXUohLzUwVF-bqp1e4ybyjj-LE.TKa0IJ-yOffGZigAN3IhGw.FnceplZMD99hLWNM2Qi_I2RkWzrld4UXXSzKuQHe2LuctbwJH1BdaJjmj-n69iJ1aiyC6BFiKqJPWKDRqyM-hRZBI8ScepB2j_RrEdZ0TP8n1Cifeeu5L_FtfAeeMCFFIxwOR19XOuGMD7DMJ109C3A6w3gBRPyPv4LT1Q12XEI.73tqCRJa8xH4ot7YB33RkIXAU2D61HmzVfAw8nFMdNw';

  useEffect(() => { 
      console.log('ViewHealthDataTestHarness useEffect running'); 
      
      // Store in localStorage as EditMetrics expects
      localStorage.setItem('member_id', '');
      localStorage.setItem('user_id', user_id);
      localStorage.setItem('auth_token', auth_token); 
  }, []);

  return (
    <IonApp>
      <IonContent>
        {member_id && user_id && auth_token ? (
          <ViewHealthData  
          />
        ) : (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <h2>Missing Authentication Data</h2>
            <p>Please provide member_id, user_id, and auth_token as URL parameters.</p>
            <p>Example: ?member_id=123&user_id=456&auth_token=abc...</p>
          </div>
        )}
      </IonContent>
    </IonApp>
  );
};

export default ViewHealthDataTestHarness;